import {h, Fragment} from "preact"
import { useActions, useAppState, useSelectedFiltersCount, useSort } from '@nosto/preact'
import { defaultConfig, sortOptions, isFrench } from '../config'
import { useEffect } from 'preact/hooks';
import useGroupProducts from '../category/useGroupProducts'

export default ({ toggleSidebar, collectionGroups }) => {
    const { query, response, pageType } = useAppState();
    const { updateSearch } = useActions();
    const { activeSort } = useSort(sortOptions);
    const selectedFiltersCount = useSelectedFiltersCount();
    const docCount = response.products?.total ?? 0;
    const { groupedHits } = useGroupProducts(collectionGroups);

    useEffect(() => {
        if(collectionGroups?.length) {
            document.documentElement.style.scrollBehavior = 'smooth';
        }
    }, [ collectionGroups ])

    return (
        <div class={`ns-header-controls flex flex-col ${pageType === 'category' ? 'ns-sticky-header' : ''}`}>
            {pageType !== 'category' && (
                <div class="ns-search-header">
                    <h1>{isFrench ? "Résultats pour" : "Search results for"} "{query.query}"</h1>
                </div>
            )}
            <div class="ns-toolbar-controls flex flex-row">
                <div class="ns-sort-container flex flex-row">
                    <span class="ns-results-count">{docCount} {isFrench ? 'Résultats' : 'Results'}</span>
                    <select
                        style={isFrench ? 'padding-right: 15px' : ''}
                        name="ns-sort-dropdown"
                        id="ns-sort-dropdown"
                        class="ns-selection-dropdown-menu ns-selection-dropdown-sort-menu ns-text-align-left"
                        value={activeSort}
                        onChange={(e) => {
                            updateSearch({
                                products: {
                                    sort: sortOptions.find(
                                        (v) => v.id === e?.target?.value
                                    )?.value?.sort,
                                },
                            })
                        }}
                    >
                        {sortOptions.map((o) => (
                            <option value={o.id} key={o.id}>
                                {isFrench ? o.value.frName : o.value.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div class="ns-tb-filter-toggle flex flex-row justify-end">
                    <button class="ns-filter-btn" type="button" onClick={toggleSidebar}>
                        {isFrench ? 'Filtres' : 'Filters'}
                    </button>
                </div>
            </div>
            {(groupedHits?.length) && (
                <div class="ns-subcollection-toggles-wrap w-full flex flex-nowrap items-center gap-5 p-5 border-t border-black-30">
                    {groupedHits.map((group, index) => (
                        group.products?.length > 0 ? (
                            <div key={index} class="ns-subcollection-toggle">
                                <a
                                    class="ns-subcollection-link whitespace-nowrap"
                                    href={`#ns-sub-collection-${index + 1}`} 
                                >
                                    {(isFrench) ? group.link.fr : group.link.en}
                                </a>
                                <span class="whitespace-nowrap">({group.products?.length})</span>
                            </div>
                        ) : ( null )
                    ))}
                </div>
            )}
        </div>
    )
}
